import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, onBeforeMount, ref, watch } from 'vue';
import { useRoute, useRouter } from 'vue-router';
import { useGettext } from '@jshmrtn/vue3-gettext';
import { Flash } from '@/core/Flash';
import UserForm from '@/modules/user/components/UserForm.vue';
import { User, useUser } from '@/modules/user/User';
import { handleLoadError } from '@/core/common';
import { Partner } from '@/modules/partner/Partner';
import { usePartnerRouteLoader } from '@/modules/partner/pages/userCommon';


export default /*@__PURE__*/_defineComponent({
  __name: 'UserEdit',
  setup(__props) {

const { $gettext, interpolate } = useGettext();
const resource = ref();
const partner = ref<Partner>();
const pageTitle = computed(() => interpolate(
	$gettext('Redigera användare för %{ name }'),
	{name: partner.value?.name || ''},
));
const route = useRoute();
const router = useRouter();
const user = ref<User | null>(null);

usePartnerRouteLoader(resource, partner);

const load = async () => {
	try {
		user.value = await useUser().get(route.params.id as string);
	} catch (e) {
		handleLoadError(e as Error, 'dashboard');
	}

	if (!user.value) {
		handleLoadError(
			new Error($gettext('Kunde inte hitta användarinformation')),
			'dashboard',
		);
	}
};

watch(route, () => {
	if (route.name === 'partner.user.edit') {
		load();
	}
});
onBeforeMount(load);

const saved = (u) => {
	user.value = u;
	Flash.success($gettext('Kontouppgifterna har uppdaterats!'));
};

const cancel = () => {
	router.push({ name: 'partner.user.index' });
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(UserForm, {
    resource: resource.value,
    "page-title": pageTitle.value,
    user: user.value,
    onSaved: saved,
    onCancel: cancel,
    "show-cancel": true
  }, null, 8, ["resource", "page-title", "user"]))
}
}

})